import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bradwestfall/Desktop/ReactTraining/Projects/monorepo/reacttraining.com/src/page-templates/BlogArticlePage.js";
import TweetEmbed from '../../../ui/blog/BlogTweetEmbed';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`On Friday night, I touched down in San Diego after an exhilarating two days in Salt Lake City at one of the best conferences I can remember, `}<a parentName="p" {...{
        "href": "http://reactrally.com/"
      }}>{`React Rally`}</a>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a895de1521961ad41659d294e74dafe6/e5166/react-rally-logo.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAeTdjZ1SAn//xAAaEAACAgMAAAAAAAAAAAAAAAABAgADEBEx/9oACAEBAAEFAqwphRdHsLY//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BJ//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPwETJ//EABYQAAMAAAAAAAAAAAAAAAAAAAEgIv/aAAgBAQAGPwKi3//EABkQAQEBAAMAAAAAAAAAAAAAAAERABBBUf/aAAgBAQABPyH3jomCqhgVGmGOR4//2gAMAwEAAgADAAAAED8f/8QAFxEBAAMAAAAAAAAAAAAAAAAAARARIf/aAAgBAwEBPxBFbH//xAAWEQADAAAAAAAAAAAAAAAAAAABECH/2gAIAQIBAT8QApf/xAAaEAEAAwADAAAAAAAAAAAAAAABABEhMVFh/9oACAEBAAE/EEUQbSJH242VWYMGFY4pVxQTGEV3rvLLn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Logo",
            "title": "Logo",
            "src": "/static/a895de1521961ad41659d294e74dafe6/4b190/react-rally-logo.jpg",
            "srcSet": ["/static/a895de1521961ad41659d294e74dafe6/e07e9/react-rally-logo.jpg 200w", "/static/a895de1521961ad41659d294e74dafe6/066f9/react-rally-logo.jpg 400w", "/static/a895de1521961ad41659d294e74dafe6/4b190/react-rally-logo.jpg 800w", "/static/a895de1521961ad41659d294e74dafe6/e5166/react-rally-logo.jpg 1200w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p><strong parentName="p">{`tl;dr:`}</strong>{` React Rally continues to surpass my expectations in every way for what a tech conference should be. If you like thoughtful discourse, inspiring talks, friendly people from many different backgrounds, and attention to detail, you owe it to yourself to attend next year.`}</p>
    <hr />
    <p>{`My personal path to this year’s Rally started a few months ago when `}<a parentName="p" {...{
        "href": "https://twitter.com/mzabriskie"
      }}>{`Matt`}</a>{` and `}<a parentName="p" {...{
        "href": "https://twitter.com/jergason"
      }}>{`Jamison`}</a>{` asked me to give one of the keynote talks. I was stoked! But I’m a terrible procrastinator, so my buddy `}<a parentName="p" {...{
        "href": "https://twitter.com/chantastic"
      }}>{`Michael Chan`}</a>{` prodded me along and even let me tag along on his trip to speak at a `}<a parentName="p" {...{
        "href": "https://www.meetup.com/ReactJS-OC/events/240421918/"
      }}>{`ReactJS OC meetup`}</a>{` back in June. That was a huge help and definitely got me thinking deeply about what I wanted to accomplish during my talk.`}</p>
    <p>{`Fast forward to this past Tuesday, and I was already getting the feeling that this conference was going to be special!`}</p>
    <TweetEmbed id="900053257917128705" mdxType="TweetEmbed" />
    <p>{`That logo set the theme for a lot of the decor and details that I’d see at the conference this week: old school video games like Frogger, Pacman, and Space Invaders on arcade machines in the hallways, neon slap-on bracelets, Lemonheads, Connect Four, beanbag chairs, the Simon Electronic Memory Game, and neon pink, purple, and green everywhere! So many of these details took me right back to my childhood.`}</p>
    <p>{`The theme carried right on through to the main stage at the Sheraton Salt Lake City where an internally-lit neon podium and two giant, glowing Rubik’s Cubes were stacked. Three huge projection screens up front made sure that everyone had a great view, and every seat but the first 3 rows had a long table where you could place your laptop.`}</p>
    <TweetEmbed id="900725797677187072" mdxType="TweetEmbed" />
    <TweetEmbed id="900735390142693377" mdxType="TweetEmbed" />
    <p>{`Putting these kinds of details and decor together takes a lot of time, effort, and money. It shows the conference organizers care. And it’s a key ingredient in building the right kind of vibe where you can feel relaxed and ready to learn something.`}</p>
    <p>{`Also, the React Rally squid was back this year as a chalk mural just outside the main hall! 🐙`}</p>
    <TweetEmbed id="901445121920516097" mdxType="TweetEmbed" />
    <p>{`Yours truly opened the conference with a talk about `}<a parentName="p" {...{
        "href": "https://unpkg.com"
      }}>{`unpkg–a`}</a>{` CDN I built back in 2015 that decompresses tarballs from the npm registry and serves up the files inside. You can watch the talk today on `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=GverPLbSqEE"
      }}>{`the recording of the live stream from day 1`}</a>{`, or you should be able to look it up later this week on `}<a parentName="p" {...{
        "href": "https://www.youtube.com/channel/UCXBhQ05nu3L1abBUGeQ0ahw"
      }}>{`React Rally’s YouTube channel`}</a>{`.`}</p>
    <TweetEmbed id="900737200051986432" mdxType="TweetEmbed" />
    <p>{`I was so stoked to go first! Being the procrastinator that I am, it let me get my talk out of the way so I could focus on relaxing and enjoying the rest of the conference instead of working on my talk. Also, after witnessing the rest of the talks, I’m pretty sure I would’ve had major anxiety if I had gone last. They were all so good!`}</p>
    <p>{`I really can’t adequately summarize every talk here, so I’m not even going to try. But I left each session feeling inspired and with a very healthy respect for the community and the breadth of problems we’re tackling. Over the course of the 2-day, single-track conference we heard talks about React (ofc!), React Native, React Native Web, D3, neural networks, Internet of Things, Redux, offline-first PWAs, WebAssembly, Accessibility, GraphQL, Webpack, Elm, contributing to open source, using native APIs in tandem with React, and much, much more.`}</p>
    <p>{`There were also several great talks about using React in the enterprise, which is an increasingly relevant topic. At `}<a parentName="p" {...{
        "href": "https://reacttraining.com"
      }}>{`React Training`}</a>{`, we are getting the chance to work with more enterprise customers every day. People are solving real problems at large scale with React, and it’s exciting to hear their stories.`}</p>
    <p>{`The talks were incredible, but amazing talks don’t make a great conference; `}<strong parentName="p">{`amazing people do`}</strong>{`. And they showed up at React Rally in spades. Just walking around and talking to people, you could `}<em parentName="p">{`feel`}</em>{` their genuine interest and support!`}</p>
    <TweetEmbed id="901198947217100800" mdxType="TweetEmbed" />
    <p>{`During the lunch break on day 2, `}<a parentName="p" {...{
        "href": "https://twitter.com/ryanflorence"
      }}>{`Ryan`}</a>{` hooked up his Nintendo Switch to the main stage projector and played Mario Kart! (Did I mention there were video games at this conference? 👾)`}</p>
    <p>{`On the evening of day 2 we all met at Salt Lake City’s Gallivan Center for BBQ brisket and pork, games, homemade popsicles, and live music under beautiful, clear skies.`}</p>
    <p>{`A camera with a green screen was setup near the stage that projected more of that awesome React Rally artwork as the background to photos we took.`}</p>
    <TweetEmbed id="901328463335784448" mdxType="TweetEmbed" />
    <p>{`Turns out my shirt was actually the SAME color green as the green screen we were standing in front of! This made for some pretty interesting shots…`}</p>
    <TweetEmbed id="901464924089532418" mdxType="TweetEmbed" />
    <p>{`And lest you think I’m gushing a little too much about the conference, I’ll let others do the talking:`}</p>
    <TweetEmbed id="901506394590806016" mdxType="TweetEmbed" />
    <TweetEmbed id="901509211946864640" mdxType="TweetEmbed" />
    <TweetEmbed id="901467779395497986" mdxType="TweetEmbed" />
    <TweetEmbed id="901383926391992321" mdxType="TweetEmbed" />
    <TweetEmbed id="901318853178802176" mdxType="TweetEmbed" />
    <TweetEmbed id="901583226946297856" mdxType="TweetEmbed" />
    <p>{`But I think this one probably sums it up best:`}</p>
    <TweetEmbed id="901288940337901569" mdxType="TweetEmbed" />
    <p>{`💕 Awwwww!`}</p>
    <p>{`Hey, life is too short to go to boring conferences with zero personality and no video games, or to pass up making great friends with great people.`}</p>
    <p><strong parentName="p">{`As I grow older, I measure the success of my life by the number of backyard BBQs I have with friends and family`}</strong>{`. We didn’t hold React Rally in my backyard, but we did eat some good BBQ and the feeling of hanging with people who I care about and who I know care about me was the same. That makes this a very successful week for me 😅`}</p>
    <p>{`I will see YOU at React Rally 2018. Don’t miss it!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      